module.exports = __webpack_public_path__ + "static/media/card.839ba0ac.svg";